let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("a1T2e")).then(() => parcelRequire('4XFKp'));